@if (isLoading) {
  <div class="overlay full">
    <p class="text-center">{{appStrings.pleaseWait}}</p>
    <mat-spinner id="productsLoader"></mat-spinner>
  </div>
}

<!-- desktop template -->
<div *appIsDesktop>
  <a [routerLink]="['/tools/catalogs']" class="home-link">{{appStrings.home}}</a>
  <app-search-product class="search-product"> </app-search-product>
  <h1>
    {{appStrings.accounts_showingResultsFor}} "{{searchString}}"
  </h1>
  @if (!isLoading) {
    <div class="product-list">
      @if (foundProducts) {
        @for (foundElem of foundProducts | paginate: {
          id: 'pagination',
          itemsPerPage: pageSize,
          currentPage: currentPage,
          totalItems: numberOfResults
          }; track foundElem; let index = $index) {
          <div
            class="product-div">
            @if (foundElem.catalogCode) {
              <img class="catalog-logo" [src]="getCatalogLogo(foundElem.catalogCode)" alt="{{foundElem.catalogCode}}" />
            }
            <a id="foundElem_{{index}}" (click)="onProductClick(foundElem)" class="cursor-pointer">
              <span class="productNumber">{{foundElem.productNumber}}</span>
              <img class="img" [src]="foundElem.image || noImage" alt="{{foundElem.name}}" appImageFallback />
              <span class="productName">{{foundElem.name}}</span>
            </a>
          </div>
        }
      } @else {
        <p class="noResults">{{appStrings.noResults}}</p>
      }
    </div>
    @if (numberOfResults > pageSize) {
      <app-pagination (pageChange)="loadPage($event)" [displayTotal]="true" [pageSize]="pageSize"></app-pagination>
    }
  }
</div>

<!-- mobile template -->
<div *appIsMobile class="mobile">
  <app-breadcrumbs></app-breadcrumbs>
  <app-search-product> </app-search-product>

  <div class="results-details">
    <span class="results-number">{{ numberOfResults }} {{ appStrings.products_resultsFor }} "{{ searchString }}"</span>
    <div class="page-size-container">
      <span>{{ appStrings.accounts_showLabel }}</span>
      <mat-form-field appearance="outline">
        <mat-select (selectionChange)="updatePageSize($event)" matNativeControl [(ngModel)]="pageSize">
          @for (option of pageSizeOptions; track option; let index = $index) {
            <mat-option [value]="option">{{ option }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  @if (!isLoading) {
    @if (foundProducts) {
      <div class="results-container">
        @for (foundElem of foundProducts; track foundElem; let index = $index) {
          <div>
            <mat-card appearance="outlined">
              <mat-card-content>
                @if (foundElem.catalogCode) {
                  <img class="catalog-logo" [src]="getCatalogLogo(foundElem.catalogCode)" alt="{{foundElem.catalogCode}}" />
                }
                <a class="result cursor-pointer" id="foundElem_{{index}}" (click)="onProductClick(foundElem)">
                  <span class="productNumber">{{foundElem.productNumber}}</span>
                  <img class="img" [src]="foundElem.image || noImage" alt="{{foundElem.name}}" appImageFallback />
                  <span class="productName">{{foundElem.name}}</span>
                </a>
              </mat-card-content>
            </mat-card>
          </div>
        }
      </div>
    } @else {
      <p class="noResults">{{appStrings.noResults}}</p>
    }
    @if (numberOfResults > pageSize) {
      <ng-container class="pagination-container text-center">
        <mat-card appearance="outlined">
          <mat-card-content>
            <mat-paginator [id]="productSearchPaginator" [length]="numberOfResults" [pageSize]="pageSize" [hidePageSize]="true"
              [showFirstLastButtons]="true" (page)="loadPageMobile($event)" [pageIndex]="currentPage">
            </mat-paginator>
          </mat-card-content>
        </mat-card>
      </ng-container>
    }
  }
</div>

<!-- common -->
